











import Vue from 'vue';
import operatoreSanitarioEdit from '@/components/commands/OperatoreSanitarioEdit.vue';

export default Vue.extend({
    components: { operatoreSanitarioEdit },
    methods: {
        close() {
            this.$router.push({
                name: 'OperatoreSanitarioList',
            });
        },
    },
});
